import { Component } from '@angular/core';

@Component({
  selector: 'app-branch-locator',
  templateUrl: './branch-locator.component.html',
  styleUrls: ['./branch-locator.component.css']
})
export class BranchLocatorComponent {

}
